module.exports = __webpack_public_path__ + "img/capa-juntos-11.ad64b6a7.png";